import BackendService from './BackendService';
import AnalyticsHelper from 'helpers/AnalyticsHelper';
import { CLARITY_EVENTS } from 'const';

async function getPriceCategories() {
  return BackendService.getData('/price-categories/');
}
async function createPriceCategory(data = {}) {
  try {
    const response = await BackendService.postData('/price-categories/', data);
    AnalyticsHelper.event(CLARITY_EVENTS.CREATE_PRICE_CATEGORY);
    return response;
  } catch (error) {
    AnalyticsHelper.event(CLARITY_EVENTS.CREATE_PRICE_CATEGORY_FAILED);
    throw error;
  }
}
async function updatePriceCategory(id, data = {}) {
  return BackendService.patch(`/price-categories/${id}/`, data);
}
async function deletePriceCategory(id, data = {}) {
  return BackendService.destroy(`/price-categories/${id}/`, data);
}
async function getItemPriceCategories() {
  return BackendService.getData('/price-categories/items/');
}
async function createItemPriceCategories(id, data) {
  return BackendService.postData(`/items/${id}/price-categories/batch/`, data);
}
async function updateItemPriceCategories(id, data) {
  return BackendService.patch(`/items/${id}/price-categories/batch/`, data);
}

const PriceCategoryService = {
  getPriceCategories,
  createPriceCategory,
  updatePriceCategory,
  deletePriceCategory,
  getItemPriceCategories,
  createItemPriceCategories,
  updateItemPriceCategories,
};

export default PriceCategoryService;
